import { provideEffects } from '@ngrx/effects';
import { provideState } from '@ngrx/store';

import { AppLockEffects } from './category-app-lock.effects';
import { appLockReducer } from './category-app-lock.reducer';

export const provideCategoryAppLockStore = () => [
  provideState('app-lock', appLockReducer),
  provideEffects([AppLockEffects]),
];
